/** sessionStorage key for post-login Job Match Score hydration (public preview funnel). */
export const MATCH_PREVIEW_CONTINUE_STORAGE_KEY = "matchPreviewContinue";

/**
 * Persist preview context before redirecting to sign-in / sign-up.
 * @param {{ resumeUrl: string, resumeName?: string, jobUrl?: string, jobDescription?: string, activeTab: 'url'|'description' }} data
 */
export function persistMatchPreviewHandoff(data) {
  try {
    sessionStorage.setItem(
      MATCH_PREVIEW_CONTINUE_STORAGE_KEY,
      JSON.stringify(data),
    );
  } catch (e) {
    // storage full / private mode — handoff best-effort only
  }
}

/** Same shape as ProtectedRoute: send user to full Job Match Score after auth. */
export function setPageToVisitJobMatchScore() {
  try {
    const accountType = localStorage.getItem("accountType");
    sessionStorage.setItem(
      "pageToVisit",
      JSON.stringify({
        accountType: accountType,
        path: "/job-match-score",
      }),
    );
  } catch (e) {
    // no-op
  }
}
